import React, { Component } from 'react';

import { TextInput, MaterialIcon } from '../../atoms';


export class PasswordInput extends Component {

	constructor(props) {
		super(props);
		this.state = {
			active: false
		};
	}


	toggleActive(active) {

	}

	render() { 
		return (
			<div className="input-password">
				<TextInput 
					type={this.state.active ? "text" : "password"} 
					label={this.props.label} 
					id={this.props.id} 
					value={this.props.value} 
					changeAction={this.props.handleChange} 
					error={this.props.error}
				/>
				<MaterialIcon
					color="grey"
					type={this.state.active ? "lock" : "remove_red_eye"}
					size="gnome"
					clickAction={() => this.setState({active: !this.state.active})}
				></MaterialIcon>
			</div>
		);
	}
};


// WEBPACK FOOTER //
// src/molecules/lib/PasswordInput.js